import { render, staticRenderFns } from "./diskRepairOptions.vue?vue&type=template&id=497cc15d&scoped=true&"
import script from "./diskRepairOptions.vue?vue&type=script&lang=js&"
export * from "./diskRepairOptions.vue?vue&type=script&lang=js&"
import style0 from "./diskRepairOptions.vue?vue&type=style&index=0&id=497cc15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cc15d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VBtnToggle,VChip,VCol,VContainer,VIcon,VRow,VSwitch})
